import React from "react";
import { useParams } from "react-router-dom"; // Import useParams
import MasterLayout from "../masterLayout/MasterLayout";
import ComplainFormPageUpdate from "../components/ComplainFormPageUpdate";

const ComplainFormUpdate = () => {
    const { id } = useParams(); // Get the id from the URL parameters
  
  return (
    <div>
      <MasterLayout>
        <ComplainFormPageUpdate  complainId={id} />
      </MasterLayout>
    </div>
  );
};

export default ComplainFormUpdate;
